/** Environment variables are strings: only the explicit value "true" enables debug. */
function isDebugEnabled(value) {
  return value === "true";
}

module.exports = { isDebugEnabled };
